import type { AppBundleIdOptionPayload, AppInventoryOptionPayload } from '@openx/types/targeting/inventoryAndContent';
import type { OptionEntriesProps } from '@openx/types/targeting/targetingValuesTypes';
import { getSelectedOptionsCount } from '../../../../InventoryAndContent/InventoryAndContentItems/utils';

type GetAppInventoryV2PreviewDataArgs = {
  appInventoryContent: AppInventoryOptionPayload;
  appBundleIdContent: AppBundleIdOptionPayload;
};

type GetAppInventoryV2PreviewDataResult = {
  appNameEntries: OptionEntriesProps[];
  bundleIdEntries: OptionEntriesProps[];
  appNameCount: number;
  bundleIdCount: number;
  hasAppNameItems: boolean;
  hasBundleIdItems: boolean;
};

export const getAppInventoryV2PreviewData = ({
  appInventoryContent,
  appBundleIdContent,
}: GetAppInventoryV2PreviewDataArgs): GetAppInventoryV2PreviewDataResult => {
  const appNameEntries: OptionEntriesProps[] = Object.entries(appInventoryContent?.val ?? {});
  const bundleIdEntries: OptionEntriesProps[] = Object.entries(appBundleIdContent?.val ?? {});
  const appNameCount = getSelectedOptionsCount(appNameEntries, 0);
  const bundleIdCount = getSelectedOptionsCount(bundleIdEntries, 0);

  const hasAppNameItems = appNameEntries.some(([, items]) => items && items.length > 0);
  const hasBundleIdItems = bundleIdEntries.some(([, items]) => items && items.length > 0);

  return {
    appNameEntries,
    bundleIdEntries,
    appNameCount,
    bundleIdCount,
    hasAppNameItems,
    hasBundleIdItems,
  };
};
